import Icon from 'snippets/icon/icon'

function CartError({ isPreOrderError, isStoreOnlyError, isInStoreOnlyError, isPralineBoxMixedLocationsError, isMixedCartError, isNotEnoughMinimum, isHoldAccount, isHoldCredit }) {
  const { preOrderError, storeOnlyError, inStoreOnlyError, pralineBoxMixedLocations, mixedCartError, minimum, holdAccountErrorCart, holdCreditErrorCart } = window.SLS_STATE.cart
  const textError = () => {
    if (isHoldAccount) {
      return holdAccountErrorCart
    } else if (isHoldCredit) {
      return holdCreditErrorCart
    } else if (isPreOrderError) {
      return preOrderError
    } else if (isStoreOnlyError) {
      return storeOnlyError
    } else if (isInStoreOnlyError) {
      return inStoreOnlyError
    } else if (isPralineBoxMixedLocationsError) {
      return pralineBoxMixedLocations
    } else if (isMixedCartError) {
      return mixedCartError
    } else if (isNotEnoughMinimum) {
      return minimum.message
    }
  }

  return (isPreOrderError || isStoreOnlyError || isInStoreOnlyError || isPralineBoxMixedLocationsError || isMixedCartError || isNotEnoughMinimum || isHoldAccount || isHoldCredit) && (
    <notice-main className="mt-4 notice-main notice-main-error">
      <button type="button" className="notice-main-icon">
        <Icon name="icon-faild" />
      </button>
      <div className="notice-main-content">
        {textError()}
      </div>
    </notice-main>
  )
}

export default CartError
